export default __webpack_public_path__ + "static/media/icon-animation.37ed1b55.svg";